import {AccordionLinkGroup} from 'shared/pretty-easy-navigation/models';
import {GroupManagementLink, LearnerManagementLink, WorkGroupManagementLink} from '../links';
import {NavigationContext} from '../navigation.context';

export const MyLearnersGroup = (context: NavigationContext): AccordionLinkGroup => ({
    type: 'accordionLinkGroup',
    label: 'navigation.my_learners',
    links: [
        GroupManagementLink(context),
        WorkGroupManagementLink(context),
        LearnerManagementLink(context)
    ],
    icon: 'navigation-group__my-learners',
});